import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Constant } from './../constant';

export interface OnBeforeunload {
  shouldDeleteLocalStorageBeforeunload: () => void;
}

@Injectable()
export class AuthGuard implements CanActivate, CanDeactivate<OnBeforeunload> {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.auth.isAuthenticated().pipe(
      tap(loggedIn => {
        const companyCode = localStorage.getItem(Constant.lsCompanyCode);
        if (!loggedIn || companyCode === '') {
          this.auth.toLoginPage();
          return;
        }

        // 画面側で data.minAuth が指定されていれば、権限チェックを行う
        const minAuth = next.data && typeof next.data['minAuth'] === 'number'
          ? next.data['minAuth'] as number
          : null;

        if (minAuth !== null && !this.auth.hasAuth(minAuth)) {
          // 権限不足時はアクセス拒否ページへ
          this.router.navigate(['/access-denied']);
        }
      })
    );
  }

  canDeactivate(component: OnBeforeunload) {
    // 各画面側でローカルストレージをクリアする
    component.shouldDeleteLocalStorageBeforeunload();
    return true;
  }
}
